import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TabsContainer, TabsPanel } from '../tabs/TabsContainer';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import VATNUMBER_CONTROLLER from '../../controllers/vatNumbers';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import SingleCountrySelector from '../selectors/country/SingleCountrySelector.jsx'
import HighlightOnInAppMessage from '../inAppMessages/HighlightOninAppMessage';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import _ from 'underscore';
import MonthSelector from '../selectors/date/MonthSelector';
import LanguageStringResolver from '../fields/language/LanguageStringResolver'
import cn from 'classnames';
import UM_MTD_CONTROLLER from '../../controllers/ukMTDVAT';
import QueryString from 'query-string';
import {withRouter} from 'react-router';
import FormattedDate from '../fields/dates/FormattedDate';
import ConfirmationModal from '../modals/ConfirmationModal'; 
import SiiSetup from './SiiSetup';
import moment from 'moment';
import StaggerCountryList  from '../../utils/staggerCountries';
import FilingFrequencySelector from '../selectors/filing/FilingFrequencySelector';
import SingleDueDatePeriodSelector from '../selectors/DueDatePeriod/SingleDueDatePeriodSelector'
import getClientConfig from '../../utils/getClientConfig.js';
import { SSelect } from "@avalara/skylab-sdk/react";

const FORM_NAME = 'VATNUMBER_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const fieldValueIsInvalid = "invalid";
const fieldValueIsValid = "valid";
const ReturnPeriodNextYear= '2';
const vatReturnQuarterFrequencyValue = 1;
const vatReturnBiMontlyFrequencyValue = 6;
const staggerOffsetPropName = "vatNumberDueDates.0.offset";
const countryCodeSii = "ES";
var selectedStaggerValue;
var selectedVATReturnFrequencyValue;
var isVATNumberCheckInProgress = false;
const radioStyle = {
    "width": "auto",
    "position": "relative"
};
const dueDatePeriods = [{"id": 0,"languageString": "vrn_DueDates_Next_Month"},{"id": 1,"languageString": "vrn_DueDates_Next_Quarter"},{"id": 2,"languageString": "vrn_DueDates_Next_Year"},{"id": 3,"languageString": "vrn_DueDates_Second_Next_Month"}];
var validClassName = fieldValueIsValid;
var localListingMonth = '',localListingPrevMonthDays = 0,localListingReturnDays = 0;
function parseQueryParams(string) {
    const originalQp =  QueryString.parse(string, {arrayFormat: 'index'});
    return _.each(originalQp, (value, key) => {return decodeURIComponent(value)});
}

export class VATNumberForm extends Component {

    constructor(props) {
        super(props);
        this.state = Object.assign({}, 
        this.state, { 
            isVATNumberAuthenticated:undefined,
            isStaggerConfirmModalPopupOpen :false,
            isFrequencyConfirmModalPopupOpen:false,
            isSiiCertificatePresent :false,
            siiCertficateDetails :null
        });
        this.siiCertficateDetails = {};
    }

    getVatNumberTypeOptions() {
        let fieldValues = this.props.formData && this.props.formData.fieldValues;
        fieldValues= MANAGED_UX_FORMS_CONTROLLER.flattenJSON(fieldValues);
        let optionsList = [];
        const vrnTypeNames = ['vrn_Type_NoReg', 'vrn_Type_Fixed', 'vrn_Type_Fiscal', 'vrn_Type_Direct', 'vrn_Type_Global', 'vrn_Type_Unknown', 'vrn_Type_HQ'];
        vrnTypeNames.forEach((val, ind) => {
            optionsList.push({
                label: LANGUAGES_CONTROLLER.format(this.props.languages, val),
                value: String(ind),
                selected: String(fieldValues.vatnumberType) === String(ind)
            });
        })
        return optionsList;
    }

    getBankOwnerTypeOptions() {
        let fieldValues = this.props.formData && this.props.formData.fieldValues;
        fieldValues= MANAGED_UX_FORMS_CONTROLLER.flattenJSON(fieldValues);
        let optionsList = [];
        const bankOwnerTypes = ['vrn_RefundProp_Type_Applicant', 'vrn_RefundProp_Type_Representative'];
        bankOwnerTypes.forEach((val, ind) => {
            optionsList.push({
                label: LANGUAGES_CONTROLLER.format(this.props.languages, val),
                value: ind+"",
                selected: fieldValues['refundProperties.bankOwnerType'] === (ind+"")? true: false
            });
        })
        return optionsList;
    }

    getIDTypeOptions() {
        let fieldValues = this.props.formData && this.props.formData.fieldValues;
        fieldValues= MANAGED_UX_FORMS_CONTROLLER.flattenJSON(fieldValues);
        let optionsList = [];
        const bankOwnerTypes = ['vrn_RefundRep_IdType_None', 'vrn_RefundRep_IdType_NVAT', 'vrn_RefundRep_IdType_TIN', 'vrn_RefundRep_IdType_Other'];
        bankOwnerTypes.forEach((val, ind) => {
            optionsList.push({
                label: LANGUAGES_CONTROLLER.format(this.props.languages, val),
                value: ind+"",
                selected: fieldValues['refundProperties.represIdTypeAuthorized'] === (ind+"")? true: false
            });
        })
        return optionsList;
    }

    getGenderOptions() {
        let fieldValues = this.props.formData && this.props.formData.fieldValues;
        fieldValues= MANAGED_UX_FORMS_CONTROLLER.flattenJSON(fieldValues);
        let optionsList = [{
            label: 'Select',
            value: '',
            selected: fieldValues['legalRepresentative.gender'] === ''? true: false
        }, {
            label: 'Male',
            value: 'M',
            selected: fieldValues['legalRepresentative.gender'] === 'M'? true: false
        },  {
            label: 'Female',
            value: 'F',
            selected: fieldValues['legalRepresentative.gender'] === 'F'? true: false
        }];
        return optionsList;
    }

    render() {
        const vrnTitle = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_Title')}</span>;
        const vrnFiscalRepTitle = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_Title')}</span>;
        const vrnFixedEstTitle = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FixedEst_Title')}</span>;
        const vrnDueDatesTitle = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_Title')}</span>;
        const vrnRefundPropTitle = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_Title')}</span>;
        const vrnRefundRepTitle = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_Title')}</span>;
        const vrnLegalRepTitle = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_LegalRep_Title')}</span>;
        const vrnSiiSetup = <span>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_esImmediate_filing_SII_Title')}</span>;
        
        const { featureFlags } = getClientConfig();
        const enableLegalRepTab = featureFlags?.EnableLegalRepTab;

        const { open } = this.state;
        let fieldValues = this.props.formData && this.props.formData.fieldValues;

        fieldValues = (fieldValues && typeof fieldValues === 'object') ? MANAGED_UX_FORMS_CONTROLLER.flattenJSON(fieldValues) : undefined;
        if (!fieldValues) {
            return (<div>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_NoData')}</div>);
        }
        var hiddenESDivClass = fieldValues.vatReturnFrequency !== 'ES' ? 'invisible' : 'visible';
        const hiddenVatReturnStaggerDivClass = this.deteremineStaggerVisibility(fieldValues.vatReturnFrequency, fieldValues.vatnumberCountry);
        const hiddenVatReturnStagger3DivClass = this.deteremineStagger3Visibility(fieldValues.vatReturnFrequency, fieldValues.vatnumberCountry);
        //Check VAT number on load, check if existing record and not validated before
        if(fieldValues.id > 0 && this.state.validValue === undefined && !_.isEmpty(fieldValues.vatnumber)
            && isVATNumberCheckInProgress === false)
            validClassName =  this.validateVATNumber(fieldValues.vatnumber,fieldValues.vatnumberCountry);
        else if(!_.isEmpty(this.state.validValue))
            validClassName = this.state.validValue;

        const modalStyle = {
            modal: {
                "maxWidth": "1080px",
                "width": "100%"
            }
        };

        //Logic to show authenticate or unauthenticate VAT number button
        var unAuthBtnClassName,authBtnClassName;
        const ukMTDClassName = cn({'invisible' : (fieldValues.vatnumberCountry !== 'GB' || fieldValues.id === 0)});
        if(fieldValues.vatnumberCountry === 'GB') {
            const parsedQueryParams = parseQueryParams(this.props.location.search);
            if(parsedQueryParams.code !== undefined || parsedQueryParams.error_description !== undefined ) {
                unAuthBtnClassName = parsedQueryParams.code !== undefined ? 'visible' : 'invisible';
                authBtnClassName = parsedQueryParams.code !== undefined ? 'invisible' : 'visible';
            }
            else if (this.state.isVATNumberAuthenticated !== undefined && this.state.isVATNumberAuthenticated === false ) {
                unAuthBtnClassName =   'invisible' ;
                authBtnClassName =  'visible';
            }
            else {
                if(this.props.vatNumber !== undefined && this.props.vatNumber.vatnumber === fieldValues.vatnumber) {
                    unAuthBtnClassName = this.props.vatNumber.vatNumberUKMTDAuthorize === false ? 'invisible' : 'visible';
                    authBtnClassName = this.props.vatNumber.vatNumberUKMTDAuthorize === true ? 'invisible' : 'visible';
                }
                else
                {
                    unAuthBtnClassName = fieldValues.vatNumberUKMTDAuthorize === false ? 'invisible' : 'visible';
                    authBtnClassName = fieldValues.vatNumberUKMTDAuthorize === true ? 'invisible' : 'visible';
                }
            }
        }
        log.debug("fieldValues.startDate",fieldValues.startDate)
        return (
            <ReadOnlyWrapper>
                <div data-testid="component-vat-number-form">
                    <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationError"/>
                    <TabsContainer>
                        <TabsPanel label={vrnTitle}>
                            <fieldset>
                                <div className="clear"></div>
                                <HighlightOnInAppMessage
                                    scopes={[FORM_NAME]}
                                    messageIds={[ALL_MESSAGES.BLANK_VATNUMBER_COUNTRY]}
                                >
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_Country')}:</label>
                                    <SingleCountrySelector countryList={this.props.countryList}  fieldName={'vatnumberCountry'} selectedCountryCode={fieldValues.vatnumberCountry} selectionHandler={this.onVATCountryChange.bind(this)}/>
                                </HighlightOnInAppMessage>
                                <HighlightOnInAppMessage
                                    scopes={[FORM_NAME]}
                                    messageIds={[ALL_MESSAGES.BLANK_VATNUMBER]}
                                >
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn')}:</label>
                                <input value={fieldValues.vatnumber} onBlur={this.onVATNumberEntered().bind(this)} className={validClassName} onChange={this.onFieldChangeHandlerFactory('vatnumber').bind(this)} />
                                </HighlightOnInAppMessage>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_Type')}:</label>
                                <SSelect defaultValue={String(fieldValues.vatnumberType ?? '')} 
                                    inputId="single-vrn_Type-select"
                                    name="company-vrn_Type"
                                    onS-select={this.onFieldChangeHandlerFactory('vatnumberType').bind(this)}
                                    optionsList={this.getVatNumberTypeOptions() || []}
                                    multiple={false}
                                    showSelectionCount={false}
                                />
                                <div className="mt10">
                                <FilingFrequencySelector
                                    selectionHandler={this.onFrequencyChangeHandler.bind(this)}
                                    value={fieldValues.vatReturnFrequency}
                                    frequencies={this.props.frequencyData.vatReturnFrequency}
                                    labelText={LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_Frequency')}
                                    fieldName={'vatReturnFrequency'}
                                />
                                </div>
                                <div className={hiddenVatReturnStaggerDivClass}>
                                    <fieldset className="mt10" role="radiogroup" aria-labelledby="label2">
                                        <input type="radio" id="r1" value = "0" onClick={this.onStaggerChangeHandler.bind(this)} checked = {fieldValues["vatNumberDueDates.0.offset"] === 0} name="stagger" aria-checked="false" />
                                        <label className="radio" htmlFor="r1" style={radioStyle}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vatNumberForm_stagger1')}</label>
                                        <input type="radio" id="r2" value = "1"  onClick={this.onStaggerChangeHandler.bind(this)} checked = {fieldValues["vatNumberDueDates.0.offset"] === 1} name="stagger" aria-checked="false" />
                                        <label className="radio" htmlFor="r2" style={radioStyle}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vatNumberForm_stagger2')}</label>
                                        <input type="radio" id="r3" value = "2" onClick={this.onStaggerChangeHandler.bind(this)} checked = {fieldValues["vatNumberDueDates.0.offset"] === 2} name="stagger" aria-checked="false" />
                                        <label className={`radio ${hiddenVatReturnStagger3DivClass}`} htmlFor="r3" style={radioStyle}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vatNumberForm_stagger3')}</label>
                                    </fieldset>
                                </div>
                                <div className="mt10">
                                <FilingFrequencySelector
                                    selectionHandler={this.onFrequencyChangeHandler.bind(this)}
                                    value={fieldValues.ecListingFrequency}
                                    frequencies={this.props.frequencyData.ecListingFrequency}
                                    labelText={LANGUAGES_CONTROLLER.format(this.props.languages, 'ecl_Frequency')}
                                    fieldName={'ecListingFrequency'}
                                />
                                </div>
                                <div className="mt10">
                                <FilingFrequencySelector
                                    selectionHandler={this.onFrequencyChangeHandler.bind(this)}
                                    value={fieldValues.localListingFrequency}
                                    frequencies={this.props.frequencyData.localListingFrequency}
                                    labelText={LANGUAGES_CONTROLLER.format(this.props.languages, 'll_Frequency')}
                                    fieldName={'localListingFrequency'}
                                />
                                </div>
                                <div className="mt10">
                                <FilingFrequencySelector
                                    selectionHandler={this.onFrequencyChangeHandler.bind(this)}
                                    value={fieldValues.intrastatInFrequency}
                                    frequencies={this.props.frequencyData.intrastatFrequency}
                                    labelText={LANGUAGES_CONTROLLER.format(this.props.languages, 'intrastatIn_Frequency')}
                                    fieldName={'intrastatInFrequency'}
                                />
                                </div>
                                <div className="mt10">
                                <FilingFrequencySelector
                                    selectionHandler={this.onFrequencyChangeHandler.bind(this)}
                                    value={fieldValues.intrastatOutFrequency}
                                    frequencies={this.props.frequencyData.intrastatFrequency}
                                    labelText={LANGUAGES_CONTROLLER.format(this.props.languages, 'intrastatOut_Frequency')}
                                    fieldName={'intrastatOutFrequency'}
                                />
                                </div>
                                <div className="mt10">
                                <FilingFrequencySelector
                                    selectionHandler={this.onFrequencyChangeHandler.bind(this)}
                                    value={fieldValues.vatBookFrequency}
                                    frequencies={this.props.frequencyData.vatReturnFrequency}
                                    labelText={LANGUAGES_CONTROLLER.format(this.props.languages, 'vatBook_Frequency')}
                                    fieldName={'vatBookFrequency'}
                                />
                                </div>
                                <div className="mt10">
                                    <FilingFrequencySelector
                                        selectionHandler={this.onFrequencyChangeHandler.bind(this)}
                                        value={fieldValues.ossUnionFrequency}
                                        frequencies={this.props.frequencyData.ossUnionFrequency}
                                        labelText={LANGUAGES_CONTROLLER.format(this.props.languages, 'ossUnion_Frequency')}
                                        fieldName={'ossUnionFrequency'}
                                    />
                                </div>
                                <div className="mt10">
                                    <FilingFrequencySelector
                                        selectionHandler={this.onFrequencyChangeHandler.bind(this)}
                                        value={fieldValues.ossNonUnionFrequency}
                                        frequencies={this.props.frequencyData.ossUnionFrequency}
                                        labelText={LANGUAGES_CONTROLLER.format(this.props.languages, 'ossNonUnion_Frequency')}
                                        fieldName={'ossNonUnionFrequency'}
                                    />
                                </div>
                                <div className="mt10">
                                    <FilingFrequencySelector
                                        selectionHandler={this.onFrequencyChangeHandler.bind(this)}
                                        value={fieldValues.ossImportFrequency}
                                        frequencies={this.props.frequencyData.ossImportFrequency}
                                        labelText={LANGUAGES_CONTROLLER.format(this.props.languages, 'ossImport_Frequency')}
                                        fieldName={'ossImportFrequency'}
                                    />
                                </div>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_TaxNumber')}:</label>
                                <input value={fieldValues.taxnumber} onChange={this.onFieldChangeHandlerFactory('taxnumber').bind(this)}/>

                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_StartDate')}:</label>

                                <FormattedDate
                                    editOptions={{
                                        fieldName: 'startDate',
                                        changeHandler: this.onFieldChangeHandlerFactory('startDate').bind(this)
                                    }}
                                    value={fieldValues.startDate && fieldValues.startDate.length > 10 ? fieldValues.startDate.substring(0,10) : (fieldValues.startDate || '')}
                                />
                                
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_ExpiryDate')}:</label>

                                <FormattedDate
                                    editOptions={{
                                        fieldName: 'expiryDate',
                                        changeHandler: this.onFieldChangeHandlerFactory('expiryDate').bind(this)
                                    }}
                                    value={fieldValues.expiryDate && fieldValues.expiryDate.length > 10 ? fieldValues.expiryDate.substring(0,10) : (fieldValues.expiryDate || '')}
                                />

                                <input className="mt10" type="checkbox"  checked={fieldValues.allowOfficialLedgerRenumbering === 1} onChange={this.onFieldChangeHandlerFactory('allowOfficialLedgerRenumbering').bind(this)}/>
                                <label className="checkbox mt10"> {LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_AllowLedgerRenumbering')}</label>
                                <span className="clear"></span>

                                <div className={hiddenESDivClass}>
                                    <hr />
                                    <input className="mt10" type="checkbox"  checked={fieldValues.immediateFilingEnabled === 1} onChange={this.onFieldChangeHandlerFactory('immediateFilingEnabled').bind(this)}/>
                                    <label className="checkbox mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_SIIEnabled')}</label>
                                    <span className="clear"></span>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_SIICertThumbprint')}:</label>
                                    <input value={fieldValues.esSiiCertificateThumbprint} onChange={this.onFieldChangeHandlerFactory('esSiiCertificateThumbprint').bind(this)}></input>
                                    <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_SIIStartDate')}:</label>
                                    <input type="date" value={fieldValues.esSiiStartDate && fieldValues.esSiiStartDate.length > 10 ? fieldValues.esSiiStartDate.substring(0,10) : (fieldValues.esSiiStartDate || '')} onChange={this.onFieldChangeHandlerFactory('esSiiStartDate').bind(this)}></input>
                                </div >
                            </fieldset>
                        </TabsPanel>
                        <TabsPanel label={vrnFiscalRepTitle}>
                            <fieldset>
                                <div className="clear"></div>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_Name')}:</label>
                                <input value={fieldValues.represName} onChange={this.onFieldChangeHandlerFactory('represName').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_FirstName')}:</label>
                                <input value={fieldValues.represPrivateFirstName} onChange={this.onFieldChangeHandlerFactory('represPrivateFirstName').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_LastName')}:</label>
                                <input  value={fieldValues.represPrivateLastName} onChange={this.onFieldChangeHandlerFactory('represPrivateLastName').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_Street')}:</label>
                                <input value={fieldValues.represAddress} onChange={this.onFieldChangeHandlerFactory('represAddress').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_HouseNumber')}:</label>
                                <input value={fieldValues.represHouseNr} onChange={this.onFieldChangeHandlerFactory('represHouseNr').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_Postcode')}:</label>
                                <input value={fieldValues.represZip} onChange={this.onFieldChangeHandlerFactory('represZip').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_City')}:</label>
                                <input value={fieldValues.represCity} onChange={this.onFieldChangeHandlerFactory('represCity').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_Telephone')}:</label>
                                <input value={fieldValues.represTel} onChange={this.onFieldChangeHandlerFactory('represTel').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_Fax')}:</label>
                                <input value={fieldValues.represFax} onChange={this.onFieldChangeHandlerFactory('represFax').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_Email')}:</label>
                                <input value={fieldValues.represEmail} onChange={this.onFieldChangeHandlerFactory('represEmail').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_VATNumber')}:</label>
                                <input value={fieldValues.represVatnumber} onChange={this.onFieldChangeHandlerFactory('represVatnumber').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_TaxNumber')}:</label>
                                <input value={fieldValues.represTaxnumber} onChange={this.onFieldChangeHandlerFactory('represTaxnumber').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FiscalRep_Country')}:</label>
                                <SingleCountrySelector disableFilterByLicence={true} countryList={this.props.countryList} fieldName={'represCountry'} selectedCountryCode={fieldValues.represCountry || ''} selectionHandler={this.onVATCountryChange.bind(this)} hideCountryCode={true}/>
                            </fieldset>
                        </TabsPanel>
                        <TabsPanel label={vrnFixedEstTitle}>
                            <fieldset>
                                <div className="clear"></div>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FixedEst_Street')}:</label>
                                <input value={fieldValues.fixEstAddress} onChange={this.onFieldChangeHandlerFactory('fixEstAddress').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FixedEst_HouseNumber')}:</label>
                                <input value={fieldValues.fixEstHouseNr} onChange={this.onFieldChangeHandlerFactory('fixEstHouseNr').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FixedEst_Postcode')}:</label>
                                <input value={fieldValues.fixEstZip} onChange={this.onFieldChangeHandlerFactory('fixEstZip').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FixedEst_City')}:</label>
                                <input value={fieldValues.fixEstCity} onChange={this.onFieldChangeHandlerFactory('fixEstCity').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FixedEst_Telephone')}:</label>
                                <input value={fieldValues.fixEstTel} onChange={this.onFieldChangeHandlerFactory('fixEstTel').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FixedEst_Fax')}:</label>
                                <input value={fieldValues.fixEstFax} onChange={this.onFieldChangeHandlerFactory('fixEstFax').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FixedEst_Email')}:</label>
                                <input value={fieldValues.fixEstEmail} onChange={this.onFieldChangeHandlerFactory('fixEstEmail').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_FixedEst_Country')}:</label>
                                <SingleCountrySelector disableFilterByLicence={true} countryList={this.props.countryList} fieldName={'fixEstCountry'} selectedCountryCode={fieldValues.fixEstCountry} selectionHandler={this.onVATCountryChange.bind(this)}  hideCountryCode={true}/>
                            </fieldset>
                        </TabsPanel>
                        <TabsPanel label={vrnDueDatesTitle}>
                            <fieldset>
                                <div className="clear"></div>
                                <s-row>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_VATReturn_before_day')}:</label>
                                        <input value={fieldValues['vatNumberDueDates.0.returnDay']} onChange={this.onFieldChangeHandlerFactory('vatNumberDueDates.0.returnDay').bind(this)}/>
                                    </s-col>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_of_the')}:</label>
                                        <SingleDueDatePeriodSelector
                                                dueDatePeriodList={dueDatePeriods}
                                                fieldName={'vatNumberDueDates.0.returnPeriod'}
                                                selectedDueDatePeriod={String(fieldValues['vatNumberDueDates.0.returnPeriod'] ?? 0)}
                                                selectionHandler={this.onDueDatePeriodChange.bind(this)}
                                        />
                                    </s-col>
                                </s-row>
                                <s-row>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_Intrastat_before_day')}:</label>
                                        <input  value={fieldValues['vatNumberDueDates.1.returnDay']} onChange={this.onFieldChangeHandlerFactory('vatNumberDueDates.1.returnDay').bind(this)}/>
                                    </s-col>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_of_the')}:</label>
                                        <SingleDueDatePeriodSelector
                                            dueDatePeriodList={dueDatePeriods}
                                            fieldName={'vatNumberDueDates.1.returnPeriod'}
                                            selectedDueDatePeriod={String(fieldValues['vatNumberDueDates.1.returnPeriod'] ?? 0)}
                                            selectionHandler={this.onDueDatePeriodChange.bind(this)}
                                        />
                                    </s-col>
                                </s-row>
                                <s-row>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_ECL_before_day')}:</label>
                                        <input value={fieldValues['vatNumberDueDates.2.returnDay']} onChange={this.onFieldChangeHandlerFactory('vatNumberDueDates.2.returnDay').bind(this)}/>
                                    </s-col>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_of_the')}:</label>
                                        <SingleDueDatePeriodSelector
                                            dueDatePeriodList={dueDatePeriods}
                                            fieldName={'vatNumberDueDates.2.returnPeriod'}
                                            selectedDueDatePeriod={String(fieldValues['vatNumberDueDates.2.returnPeriod'] ?? 0)}
                                            selectionHandler={this.onDueDatePeriodChange.bind(this)}
                                        />
                                    </s-col>
                                </s-row>
                                <s-row>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_LL_before_day')}:</label>
                                        <input value={Number.isInteger(fieldValues['vatNumberDueDates.3.returnDay']) ? (fieldValues['vatNumberDueDates.3.returnDay'] - (this.localListingPrevMonthDays || 0)) : fieldValues['vatNumberDueDates.3.returnDay']} onChange={this.onFieldChangeHandlerFactory('vatNumberDueDates.3.returnDay').bind(this)}/>
                                    </s-col>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_of_the_month')}:</label>
                                        <MonthSelector month={this.localListingMonth || '1'} selectionHandler={this.onMonthChange.bind(this)} disabled={Number(fieldValues['vatNumberDueDates.3.returnPeriod']) === 2  ? "":"disabled"} />
                                    </s-col>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_of_the')}:</label>
                                        <SingleDueDatePeriodSelector
                                            dueDatePeriodList={dueDatePeriods}
                                            fieldName={'vatNumberDueDates.3.returnPeriod'}
                                            selectedDueDatePeriod={String(fieldValues['vatNumberDueDates.3.returnPeriod'] ?? 0)}
                                            selectionHandler={this.onDueDatePeriodChange.bind(this)}
                                        />
                                    </s-col>
                                </s-row>
                                <s-row>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_ossUnion_before_day')}:</label>
                                        <input value={fieldValues['vatNumberDueDates.13.returnDay']} onChange={this.onFieldChangeHandlerFactory('vatNumberDueDates.13.returnDay').bind(this)}/>
                                    </s-col>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_of_the')}:</label>
                                        <SingleDueDatePeriodSelector
                                            dueDatePeriodList={dueDatePeriods}
                                            fieldName={'vatNumberDueDates.13.returnPeriod'}
                                            selectedDueDatePeriod={String(fieldValues['vatNumberDueDates.13.returnPeriod'] ?? 0)}
                                            selectionHandler={this.onDueDatePeriodChange.bind(this)}
                                        />
                                    </s-col>
                                </s-row>
                                <s-row>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_ossNonUnion_before_day')}:</label>
                                        <input value={fieldValues['vatNumberDueDates.14.returnDay']} onChange={this.onFieldChangeHandlerFactory('vatNumberDueDates.14.returnDay').bind(this)}/>
                                    </s-col>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_of_the')}:</label>
                                        <SingleDueDatePeriodSelector
                                            dueDatePeriodList={dueDatePeriods}
                                            fieldName={'vatNumberDueDates.14.returnPeriod'}
                                            selectedDueDatePeriod={String(fieldValues['vatNumberDueDates.14.returnPeriod'] ?? 0)}
                                            selectionHandler={this.onDueDatePeriodChange.bind(this)}
                                        />
                                    </s-col>
                                </s-row>
                                <s-row>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_ossImport_before_day')}:</label>
                                        <input value={fieldValues['vatNumberDueDates.12.returnDay'] || 1} onChange={this.onFieldChangeHandlerFactory('vatNumberDueDates.12.returnDay').bind(this)}/>
                                    </s-col>
                                    <s-col span="3">
                                        <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_DueDates_of_the')}:</label>
                                        <SingleDueDatePeriodSelector
                                            dueDatePeriodList={dueDatePeriods}
                                            fieldName={'vatNumberDueDates.12.returnPeriod'}
                                            selectedDueDatePeriod={String(fieldValues['vatNumberDueDates.12.returnPeriod'] ?? 0)}
                                            selectionHandler={this.onDueDatePeriodChange.bind(this)}
                                        />
                                    </s-col>
                                </s-row>
                            </fieldset>
                        </TabsPanel>
                        <TabsPanel label={vrnRefundPropTitle}>
                            <fieldset>
                                <div className="clear"></div>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_Owner')}:</label>
                                <input value={fieldValues['refundProperties.bankOwnerName']} onChange={this.onFieldChangeHandlerFactory('refundProperties.bankOwnerName').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_Type')}:</label>
                                <SSelect defaultValue={fieldValues['refundProperties.bankOwnerType']} 
                                    inputId="single-bankOwnerType-select"
                                    name="bankOwnerType"
                                    onS-select={this.onFieldChangeHandlerFactory('refundProperties.bankOwnerType').bind(this)}
                                    optionsList={this.getBankOwnerTypeOptions() || []}
                                    multiple={false}
                                    showSelectionCount={false}
                                />
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_IBAN')}:</label>
                                <input value={fieldValues['refundProperties.bankIban']} onChange={this.onFieldChangeHandlerFactory('refundProperties.bankIban').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_BIC')}:</label>
                                <input value={fieldValues['refundProperties.bankBic']} onChange={this.onFieldChangeHandlerFactory('refundProperties.bankBic').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_Currency')}:</label>
                                <input value={fieldValues['refundProperties.bankCurrency']} onChange={this.onFieldChangeHandlerFactory('refundProperties.bankCurrency').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_BankName')}:</label>
                                <input value={fieldValues['refundProperties.bankName']} onChange={this.onFieldChangeHandlerFactory('refundProperties.bankName').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_BankStreet')}:</label>
                                <input value={fieldValues['refundProperties.bankStreet']} onChange={this.onFieldChangeHandlerFactory('refundProperties.bankStreet').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_BankStreetNo')}:</label>
                                <input value={fieldValues['refundProperties.bankStreetNr']} onChange={this.onFieldChangeHandlerFactory('refundProperties.bankStreetNr').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_BankPostcode')}:</label>
                                <input value={fieldValues['refundProperties.bankZip']} onChange={this.onFieldChangeHandlerFactory('refundProperties.bankZip').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_BankCity')}:</label>
                                <input value={fieldValues['refundProperties.bankCity']} onChange={this.onFieldChangeHandlerFactory('refundProperties.bankCity').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_BankCountryCode')}:</label>
                                <input value={fieldValues['refundProperties.bankCountry']} onChange={this.onFieldChangeHandlerFactory('refundProperties.bankCountry').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundProp_NACECode')}:</label>
                                <input value={fieldValues['refundProperties.businessNace']} onChange={this.onFieldChangeHandlerFactory('refundProperties.businessNace').bind(this)}/>
                            </fieldset>
                        </TabsPanel>
                        <TabsPanel label={vrnRefundRepTitle}>
                            <fieldset>
                                <div className="clear"></div>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_Name')}:</label>
                                <input value={fieldValues['refundProperties.represName']} onChange={this.onFieldChangeHandlerFactory('refundProperties.represName').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_Street')}:</label>
                                <input value={fieldValues['refundProperties.represAddressStreet']} onChange={this.onFieldChangeHandlerFactory('refundProperties.represAddressStreet').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_StreetNo')}:</label>
                                <input value={fieldValues['refundProperties.represAddresNumber']} onChange={this.onFieldChangeHandlerFactory('refundProperties.represAddresNumber').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_Postcode')}:</label>
                                <input value={fieldValues['refundProperties.represAddresZip']} onChange={this.onFieldChangeHandlerFactory('refundProperties.represAddresZip').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_City')}:</label>
                                <input value={fieldValues['refundProperties.represAddresCity']} onChange={this.onFieldChangeHandlerFactory('refundProperties.represAddresCity').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_CountryCode')}:</label>
                                <input value={fieldValues['refundProperties.represCountry']} onChange={this.onFieldChangeHandlerFactory('refundProperties.represCountry').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_Email')}:</label>
                                <input value={fieldValues['refundProperties.represEmail']} onChange={this.onFieldChangeHandlerFactory('refundProperties.represEmail').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_Telephone')}:</label>
                                <input value={fieldValues['refundProperties.represTelephone']} onChange={this.onFieldChangeHandlerFactory('refundProperties.represTelephone').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_Fax')}:</label>
                                <input value={fieldValues['refundProperties.represFax']} onChange={this.onFieldChangeHandlerFactory('refundProperties.represFax').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_Identification')}:</label>
                                <input value={fieldValues['refundProperties.represId']} onChange={this.onFieldChangeHandlerFactory('refundProperties.represId').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_CountryId')}:</label>
                                <input value={fieldValues['refundProperties.represIdCountry']} onChange={this.onFieldChangeHandlerFactory('refundProperties.represIdCountry').bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_RefundRep_IdType')}:</label>
                                <SSelect defaultValue={fieldValues['refundProperties.represIdTypeAuthorized']} 
                                    inputId="single-bankOwnerType-select"
                                    name="represIdTypeAuthorized"
                                    onS-select={this.onFieldChangeHandlerFactory('refundProperties.represIdTypeAuthorized').bind(this)}
                                    optionsList={this.getIDTypeOptions() || []}
                                    multiple={false}
                                    showSelectionCount={false}
                                />
                            </fieldset>
                        </TabsPanel>
                        {enableLegalRepTab ? 
                        <TabsPanel label={vrnLegalRepTitle} datatestid={'legal-rep-tab'}>
                            <fieldset>
                                <div className="clear"></div>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_LegalRep_FirstName')}:</label>
                                <input value={fieldValues['legalRepresentative.firstName']} data-testid='legal-rep-first-name' onChange={this.onFieldChangeHandlerFactory('legalRepresentative.firstName', 255).bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_LegalRep_LastName')}:</label>
                                <input value={fieldValues['legalRepresentative.lastName']} data-testid='legal-rep-last-name' onChange={this.onFieldChangeHandlerFactory('legalRepresentative.lastName', 255).bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_LegalRep_BirthDate')}:</label>
                                <FormattedDate
                                    editOptions={{
                                        fieldName: 'legalRepresentative.dateOfBirth',
                                        changeHandler: this.onFieldChangeHandlerFactory('legalRepresentative.dateOfBirth').bind(this)
                                    }}
                                    value={fieldValues['legalRepresentative.dateOfBirth'] && fieldValues['legalRepresentative.dateOfBirth'].length > 10 ? fieldValues['legalRepresentative.dateOfBirth'].substring(0,10) : (fieldValues['legalRepresentative.dateOfBirth'] || '')}
                                />
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_LegalRep_BirthPlace')}:</label>
                                <input value={fieldValues['legalRepresentative.placeOfBirth']} data-testid='legal-rep-birth-place' onChange={this.onFieldChangeHandlerFactory('legalRepresentative.placeOfBirth', 255).bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_LegalRep_BirthProvince')}:</label>
                                <input value={fieldValues['legalRepresentative.provinceOfBirth']} placeholder='Enter code' data-testid='legal-rep-birth-province' onChange={this.onFieldChangeHandlerFactory('legalRepresentative.provinceOfBirth', 2).bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_LegalRep_Gender')}:</label>
                                <SSelect defaultValue={fieldValues['legalRepresentative.gender']} 
                                    inputId="single-gender-select"
                                    name="gender"
                                    onS-select={this.onFieldChangeHandlerFactory('legalRepresentative.gender').bind(this)}
                                    optionsList={this.getGenderOptions() || []}
                                    multiple={false}
                                    showSelectionCount={false}
                                />
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_LegalRep_TaxNumber')}:</label>
                                <input value={fieldValues['legalRepresentative.taxNumber']} data-testid='legal-rep-tax-number' onChange={this.onFieldChangeHandlerFactory('legalRepresentative.taxNumber', 100).bind(this)}/>
                                <label className="mt10">{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_LegalRep_RepresentationType')}:</label>
                                <input value={fieldValues['legalRepresentative.representationType']} placeholder='Enter numeric code' data-testid='legal-rep-representation-type' onChange={this.onFieldChangeHandlerFactory('legalRepresentative.representationType', 2).bind(this)}/>
                            </fieldset>
                        </TabsPanel>
                        : <div></div>}
                        {(fieldValues.vatnumberCountry === countryCodeSii && !this.props.isAddMode) ? (
                            <TabsPanel label={vrnSiiSetup}>
                                <SiiSetup fieldValues = {fieldValues} 
                                        siiCertficateDetails = {this.state.siiCertficateDetails}
                                        onSiiFieldChangeHandler = {this.onSiiFieldChangeHandler.bind(this)}
                                        onSiiCertificateUpload= {this.onSiiCertificateUpload.bind(this)}
                                        onSiiCertificateClear = {this.onSiiCertificateClear.bind(this)}
                                        />
                            </TabsPanel>
                        ):(
                            <div></div>
                        )}
                    </TabsContainer>
                    <div className="bottom-nav-panel-sticky mt20">
                        <div className="bottom-nav-panel">
                            <div className={ukMTDClassName}>
                                <div className={authBtnClassName}>
                                    <button className="primary mt0 mb10 mtd-authenticate-needed" onClick={this.onAuthenticateVATNumber.bind(this)}><LanguageStringResolver string='MTD_AuthenticateVATNumber'/></button>
                                </div>
                                <div className={unAuthBtnClassName}>
                                    <button className="primary mt0 mb10" onClick={this.onUnauthenticateVATNumber.bind(this)}><LanguageStringResolver string='MTD_UnauthenticateVATNumber'/></button>
                                </div>
                            </div>
                            <div className="clear"></div>

                            <button data-test="button-save-vat-number" className="primary" onClick={this.onSubmitForm.bind(this)}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_Submit')}</button>
                            {
                                this.props.showDelete ?	
                                (<button data-test="button-delete-vat-number" className="secondary delete" onClick={this.onDeleteVATNumber.bind(this)}>{LANGUAGES_CONTROLLER.format(this.props.languages, 'vrn_Delete')}</button>) :	
                                (<span></span>)	
                            }
                        </div>
                    </div>
                    <div>
                        <ConfirmationModal isModalPopupOpen={this.state.isStaggerConfirmModalPopupOpen}
                            modelTitle = "confirmationModal_TitleStaggerChange" 
                            modelMessage = "vatNumberForm_staggerChangeDisclaimer" 
                            onYesClickHandler = {this.onYesClickStaggerChangeHandler.bind(this)}
                            onCancelClickHandler = {this.onCancelClickStaggerChangeHandler.bind(this)}
                            />
                        <ConfirmationModal isModalPopupOpen={this.state.isFrequencyConfirmModalPopupOpen}
                            modelTitle = "confirmationModal_TitleVATReturnFrequencyChange" 
                            modelMessage = "vatNumberForm_vatReturnFrequenctChangeDisclaimer" 
                            onYesClickHandler = {this.onYesClickVATFrequecyChangeHandler.bind(this)}
                            onCancelClickHandler = {this.onCancelClickVATFrquencyChangeHandler.bind(this)}
                            />
                    </div>
                </div>
            </ReadOnlyWrapper>
            
        );
    }
    componentWillUnmount() {
      //  this.props.doDestroyForm(this.props.FORM_NAME_FOR_VATNumber);
    }
    componentDidUpdate(prevProps) {
        if(this.props.vatNumber != prevProps.vatNumber){
            this.props.doInitialiseForm(this.props.FORM_NAME_FOR_VATNumber, this.props.vatNumber); 
        }
        //SII certificate tab is only required for when country is spain(ES),when country changed from spain to different
        //then we need to clear the state of SiiSetup form.Below code is taking care of it
        if(this.props.formData && 
           this.props.formData.fieldValues && 
           this.props.formData.fieldValues.vatnumberCountry !== countryCodeSii &&
           prevProps.formData &&
           prevProps.formData.fieldValues &&
           prevProps.formData.fieldValues.vatnumberCountry === countryCodeSii 
         ){
            this.onSiiCertificateClear();
        };
        //In SII Set up form ,there are two update transaction requests are sending to database
        //1 .Company Data Save 2.After success of company SAVE , ES SII certificate SAVE is happing
        //If any error occurs during 2nd request ,then error message is getting displayed on VATNUmberForm.jsx
        //Hence below condition will monitor the changed state of saveCertificate and display error if it fails.
        if(this.props.saveCertificate !== prevProps.saveCertificate && this.props.saveCertificate === false){
            log.setDictionaryMessage(ALL_MESSAGES.SAVE_SII_CERTIFICATE_ERROR,this.props.saveCertificateError.message);
        }
      }
    UNSAFE_componentWillMount() {
        log.clearDictionaryError(ALL_MESSAGES.BLANK_VATNUMBER);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_VATNUMBER_COUNTRY);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_SII_CERTIFICATE);
        log.clearDictionaryError(ALL_MESSAGES.SII_ENDDATE_VALIDATION_ERROR);
        
        this.props.doInitialiseForm(this.props.FORM_NAME_FOR_VATNumber, this.props.vatNumber);
        validClassName = fieldValueIsValid;
    }

    onDueDatePeriodChange(keyValue) {
        log.debug('onDueDatePeriodChange(): ', keyValue);
        let fieldName = '', value = ''
        for(let i in keyValue) {
            fieldName = i;
            value = keyValue[i];
            this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber, fieldName, value);
        }
    }
    onMonthChange(keyValue) {
        log.debug('onMonthChange: ', keyValue,this.props.formData.fieldValues['vatNumberDueDates.3.returnDay'],this.localListingReturnDays);
        let value = '', returnDays,returnDaysUpdated;
        let returnDaysOriginal = this.props.formData.fieldValues['vatNumberDueDates.3.returnDay'] !== undefined ? this.props.formData.fieldValues['vatNumberDueDates.3.returnDay'] :this.localListingReturnDays;
         if(this.localListingPrevMonthDays !== undefined)
         {
             log.debug('onMonthChange: inside if ',this.localListingPrevMonthDays,returnDaysOriginal);
             returnDaysOriginal = returnDaysOriginal - this.localListingPrevMonthDays;
         }
        for (var i in keyValue) {
            value = keyValue[i];
            //On Month drop down select add total days till selected month to localListingReturnDays
            returnDays = this.daysInMonth(value);
            log.debug('onMonthChange: returnDays', returnDays,returnDaysUpdated,returnDaysOriginal);
            returnDaysUpdated = returnDays + Number(returnDaysOriginal || 0);
            log.debug('onMonthChange: returnDays 2', returnDaysUpdated);
            this.localListingMonth = value;
            this.localListingPrevMonthDays = returnDays;
            this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber, 'vatNumberDueDates.3.returnDay', returnDaysUpdated);
        }
        return;
    }

    //Method to get Month and date by provided day of the year
    //For Local listing day of the year is stored and on UI Month and day shown
    getMonthFromDay(day)
    {
        log.debug('getMonthFromDay',this.localListingPrevMonthDays,day);
        if(this.localListingPrevMonthDays === undefined || this.localListingPrevMonthDays === 0) {
            log.debug('getMonthFromDay: ', day);
            var d = new Date();
            this.localListingReturnDays = day;
            var returnDay = day, dayTillMonth = 0, daysinCurrentMonth = 0;
            //Check if date is less than first month
            if (day <= 31) {
                this.localListingMonth = 1;
                this.localListingPrevMonthDays = 0;
                log.debug('getMonthFromDay: in first if', this.localListingMonth, this.localListingPrevMonthDays);
                return;
            }
            //Execute for loop for all months to calcualte day of the year
            for (var i = 1; i < 12; i++) {
                daysinCurrentMonth = (new Date(d.getFullYear() + 1, i, 0).getDate());
                returnDay = returnDay - daysinCurrentMonth;
                log.debug('getMonthFromDay inside look',daysinCurrentMonth,dayTillMonth,returnDay)
                if (returnDay <= 0) {
                    this.localListingMonth = i;
                    this.localListingPrevMonthDays = dayTillMonth;
                    return {day: returnDay, month: i};
                }
                dayTillMonth = dayTillMonth + daysinCurrentMonth;
            }
        }
    }

    //Method to get number of days till provided month in the year
    daysInMonth(month) {
        //Get current date
        var d = new Date();
        var dayTillMonth = 0;
        //To get days for next year for all prev months
        for(var i =1; i < month; i++)
        {
            dayTillMonth = (new Date(d.getFullYear() + 1, i, 0).getDate()) + dayTillMonth;
        }
        return dayTillMonth;
    }

    onVATCountryChange(keyValue)
    {

        var fieldName = '', value = ''
        this.onVATNumberEntered();

        for(var i in keyValue) {
            fieldName = i;
            value = keyValue[i]
            log.debug('onCountryChange(): ', i,keyValue[i]);

            this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber, fieldName, value);
        }
        if(fieldName === 'vatnumberCountry') {
            if (!(typeof this.props.formData.fieldValues.vatnumber !== 'string' || this.props.formData.fieldValues.vatnumber.trim().length === 0)
                && (!(value === undefined || value === '')
                )) {
                this.validateVATNumber(this.props.formData.fieldValues.vatnumber, value);
            }
        }
    }

 	onVATNumberEntered() {
      return () => {
           log.debug('onVATNumberEntered()',this.props.formData.fieldValues.vatnumberCountry);
           if (!(typeof this.props.formData.fieldValues.vatnumber !== 'string' || this.props.formData.fieldValues.vatnumber.trim().length === 0)
           && (!(typeof this.props.formData.fieldValues.vatnumberCountry !== 'string' || this.props.formData.fieldValues.vatnumberCountry.trim().length === 0)
                   ) )
           {this.validateVATNumber(this.props.formData.fieldValues.vatnumber,this.props.formData.fieldValues.vatnumberCountry)}
     }
    }

    validateVATNumber(vatNumber,country)
    {
        var res = true;
        const regEx = _.find(this.props.vatValidationRules, function (elem) {
            return elem.key === country;
        });
        if(regEx && regEx.value) {
            res = regEx.value.test(vatNumber);
            if (!res) {
                this.setState({
                    validValue: fieldValueIsInvalid
                })
            }
        }
        if(res)
        {
            var callback = (response) => {
                if (response.vatNumber == this.props.formData.fieldValues.vatnumber) {
                    isVATNumberCheckInProgress = false;
                    var technicalCheck = response.technicalCheck === true ? fieldValueIsValid : fieldValueIsInvalid;
                    if (this.state.validValue !== technicalCheck) {
                        this.setState({
                            validValue: technicalCheck
                        });
                    }
                }
            };
            //If VAT number pass reg ex then perform deep check (SaaS API)
            isVATNumberCheckInProgress = true;
            this.props.doValidateVATNumber(vatNumber.trim(), callback);
        }
    }
    onFrequencyChangeHandler(filingFrequency, fieldName)
    {
        const fieldValues = MANAGED_UX_FORMS_CONTROLLER.flattenJSON(this.props.formData?.fieldValues);
        const hiddenVatReturnStaggerDivClass = this.deteremineStaggerVisibility(fieldValues.vatReturnFrequency, fieldValues.vatnumberCountry);
        if(fieldName === 'vatReturnFrequency') {
            if (!this.props.isAddMode && hiddenVatReturnStaggerDivClass === "visible") {
                this.setState({isFrequencyConfirmModalPopupOpen: true});
                this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber, fieldName, filingFrequency.id)
            }
            if (hiddenVatReturnStaggerDivClass === "invisible" || this.props.isAddMode) {
                this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber, fieldName, filingFrequency.id)
            }
        }
        else
            this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber, fieldName, filingFrequency.id)
    }
    onStaggerChangeHandler(evt){
        selectedStaggerValue = Number(evt.target.value);
        if (!this.props.isAddMode && this.props.formData.fieldValues["vatNumberDueDates.0.offset"] !==selectedStaggerValue){
            this.setState({ isStaggerConfirmModalPopupOpen : true });

        }
        if (this.props.isAddMode && this.props.formData.fieldValues["vatNumberDueDates.0.offset"] !==selectedStaggerValue){
             this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber,staggerOffsetPropName , selectedStaggerValue)
        }
    }
    onCancelClickStaggerChangeHandler(){
        this.setState({ isStaggerConfirmModalPopupOpen : false });
        return;
    }
    onCancelClickVATFrquencyChangeHandler(){
        this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber,'vatReturnFrequency', 1)
        this.setState({ isFrequencyConfirmModalPopupOpen : false });
        return;
    }
    deteremineStaggerVisibility(vatReturnFrequency,vatnumberCountry) {
        if (_.find(StaggerCountryList, (countryCode) => { return countryCode === vatnumberCountry }) != null) {
            if ((vatnumberCountry === "ZA" && vatReturnFrequency === vatReturnBiMontlyFrequencyValue) || (vatnumberCountry !== "ZA" && vatReturnFrequency === vatReturnQuarterFrequencyValue)) {
                return "visible";
            }
        }
        return "invisible";
   }
   deteremineStagger3Visibility(vatReturnFrequency, vatnumberCountry){
        return (vatnumberCountry === "ZA" && vatReturnFrequency === vatReturnBiMontlyFrequencyValue) ? "invisible" : "visible";
  }
   onYesClickStaggerChangeHandler(){
       this.setState({ isStaggerConfirmModalPopupOpen : false });
       this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber,staggerOffsetPropName , selectedStaggerValue)
   }
   onYesClickVATFrequecyChangeHandler(){
    this.setState({ isFrequencyConfirmModalPopupOpen : false });
    this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber,'vatReturnFrequency' , selectedVATReturnFrequencyValue);
    this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber,staggerOffsetPropName , 0);
   }
   onSiiFieldChangeHandler(fieldName,value,isCertficateDeleted){
     //This value will be used during VAT NUmber SAVE.
     //While TAB switch we need to store the state of certificate Hence passing its state from Parent(VATNumberForm.jsx) 
        if(fieldName === "password"){
            this.siiCertficateDetails.certificatePassword = value;
            this.setState({isSiiCertificatePresent : false,siiCertficateDetails:this.siiCertficateDetails});
        }else{
        this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber, fieldName, value)
            if(isCertficateDeleted){
                this.onSiiCertificateClear();
                this.props.onDeleteSIICertificateHandle();
            }
        }
   }
   onSiiCertificateUpload(siiCertficateDetails){
       //This value will be used during VAT Number SAVE.
       //While TAB switch we need to store the state of certificate Hence passing its state from Parent(VATNumberForm.jsx) 
       this.siiCertficateDetails = siiCertficateDetails;
       this.setState({isSiiCertificatePresent : true,siiCertficateDetails:siiCertficateDetails});
   }
   onSiiCertificateClear(){
       //This value will be used during VAT NUmber SAVE.
       //While TAB switch we need to store the state of certificate Hence passing its state from Parent(VATNumberForm.jsx) 
        this.siiCertficateDetails = {};
        this.setState({isSiiCertificatePresent : false,siiCertficateDetails :null});
   }
   
    onFieldChangeHandlerFactory(fieldName, maxLength = null) {
        return (evt) => {
            
            log.clearDictionaryError(ALL_MESSAGES.BLANK_VATNUMBER);
            log.clearDictionaryError(ALL_MESSAGES.BLANK_VATNUMBER_COUNTRY);
            log.clearDictionaryError(ALL_MESSAGES.BLANK_SII_CERTIFICATE);
            log.clearDictionaryError(ALL_MESSAGES.SII_ENDDATE_VALIDATION_ERROR);
            
           // log.debug('onFieldChangeHandlerFactory(): ', fieldName,evt.target.value);
            let value;
            switch (fieldName) {
                case 'allowOfficialLedgerRenumbering':
                case 'immediateFilingEnabled':
                    value = evt.target.checked  ? 1 : 0;
                    break;
                case 'represIdTypeAuthorized':
                case 'represCountry':
                case 'fixEstCountry':
                    value = Number(evt.target.value);
                    break;
                case 'vatNumberDueDates.3.returnDay':
                    log.debug('onFieldChangeHandlerFactory():',this.props.formData.fieldValues['vatNumberDueDates.3.returnPeriod'],ReturnPeriodNextYear);
                    //For locallsiting if selected period is next year then set return day as day of year else normal day
                    if(this.props.formData.fieldValues['vatNumberDueDates.3.returnPeriod'] === ReturnPeriodNextYear) {
                        log.debug('onFieldChangeHandlerFactory(): inside if');
                        value = Number(evt.target.value) + (this.localListingPrevMonthDays || 0);
                    }
                    else
                    {
                        log.debug('onFieldChangeHandlerFactory(): inside else',evt.target.value,Number.isInteger(evt.target.value));
                        //initialise variables if next year not selected
                        value = evt.target.value;
                        this.localListingPrevMonthDays = 0;
                        this.localListingMonth = 1;
                        this.localListingReturnDays = 0;
                    }
                    break;
                case 'vatnumberType':
                    value = evt.detail.item.value;
                    break;
                case 'refundProperties.represIdTypeAuthorized':
                    value = evt.detail.item.value;
                    break;
                case 'refundProperties.bankOwnerType':
                    value = evt.detail.item.value;
                    break;
                case 'startDate':
                case 'expiryDate':
                case 'legalRepresentative.dateOfBirth':
                    value = evt;
                    log.debug("onFieldChangeHandlerFactory formatted value", value)
                    break;
                case 'legalRepresentative.gender':
                    value = evt.detail.item.value;
                    break;
                case 'legalRepresentative.representationType':
                    value = maxLength ? (evt.target.value).slice(0, maxLength) : evt.target.value;
                    value = value.replace(/\D/g, '');
                    break;
                default:
                    value = maxLength ? (evt.target.value).slice(0, maxLength) : evt.target.value;
                    log.debug("onFieldChangeHandlerFactory value", value)
            }
            this.props.onFieldChange(this.props.FORM_NAME_FOR_VATNumber, fieldName, value)
        }
    }

    onDeleteVATNumber() {
        log.debug('onDeleteVATNumber(): ', this.props.formData.fieldValues.vatnumber,this.props.deleteHandler);

        this.props.deleteHandler(this.props.formData.fieldValues.vatnumber)
        this.props.doDestroyForm(this.props.FORM_NAME_FOR_VATNumber);
    }

    onAuthenticateVATNumber()
    {
        log.debug('onAuthenticateVATNumber(): ', this.props.companyCode);
        const redirectURL = this.props.ukMTDAuthorizationurl + '?vatnumber=' + this.props.formData.fieldValues.vatnumber + '_' + this.props.companyCode.replace(/\s/g, "");
        log.debug('onAuthenticateVATNumber(): ', redirectURL);
        this.setState({ isVATNumberAuthenticated : true });
        window.open(redirectURL , '_self');
    }

    onUnauthenticateVATNumber()
    {
        log.debug('onUnauthenticateVATNumber ');
        this.props.doUnauthenticateVATNumber(this.props.formData.fieldValues.vatnumber);
        this.setState({ isVATNumberAuthenticated : false });
        window.open(this.props.ukMTDmanageAuthorityURL, '_blank');
    }

    onSubmitForm() {
        log.debug('onSubmitForm(): ',this.props.formData.fieldValues.vatNumberDueDates[3],localListingPrevMonthDays);
        log.debug('onSubmitForm(): ',ALL_MESSAGES.BLANK_VATNUMBER);
        if (!this.props.formData || typeof this.props.formData.fieldValues !== 'object') {
            return; // TODO: Maybe a dialog to confirm blank entry?
        }

        let fieldsOk = true;
        log.clearDictionaryError(ALL_MESSAGES.BLANK_VATNUMBER);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_VATNUMBER_COUNTRY);
        log.clearDictionaryError(ALL_MESSAGES.BLANK_SII_CERTIFICATE);
        log.clearDictionaryError(ALL_MESSAGES.SII_ENDDATE_VALIDATION_ERROR);

        let vatnumberCountry = '';
        if (this.props.formData.fieldValues.vatnumberCountry !== undefined)	
        {	
            vatnumberCountry = this.props.formData.fieldValues.vatnumberCountry.trim();	
        }
        const vatnumber = this.props.formData.fieldValues.vatnumber.trim();

        if ( vatnumberCountry === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_VATNUMBER_COUNTRY);
            fieldsOk = false;
        }
        if ( vatnumber === '') {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_VATNUMBER);
            fieldsOk = false;
        }
        if ( !this.state.isSiiCertificatePresent && this.siiCertficateDetails.certificatePassword && this.siiCertficateDetails.certificatePassword !== "") {
            log.setDictionaryMessage(ALL_MESSAGES.BLANK_SII_CERTIFICATE);
            fieldsOk = false;
        }
        if(this.props.formData.fieldValues.regPrevioGGEEoREDEMEoCompetenciaStartDate &&
            this.props.formData.fieldValues.regPrevioGGEEoREDEMEoCompetenciaEndDate &&
            !this.props.formData.fieldValues.regPrevioGGEEoREDEMEoCompetenciaStartDate.startsWith('1899') &&
            !this.props.formData.fieldValues.regPrevioGGEEoREDEMEoCompetenciaEndDate.startsWith('1899') 
        ){
            if(moment(this.props.formData.fieldValues.regPrevioGGEEoREDEMEoCompetenciaStartDate) > moment(this.props.formData.fieldValues.regPrevioGGEEoREDEMEoCompetenciaEndDate)){
                log.setDictionaryMessage(ALL_MESSAGES.SII_ENDDATE_VALIDATION_ERROR);
                fieldsOk = false;
            }
        }

        if (!fieldsOk) {
            return;
        }
        //For locallisting if period is not next year, set returndays to day and not day of year
        if(this.props.formData.fieldValues.vatNumberDueDates[3] && this.props.formData.fieldValues.vatNumberDueDates[3].returnPeriod !== ReturnPeriodNextYear)
        {
            log.debug('onSubmitForm(): inside if',this.props.formData.fieldValues.vatNumberDueDates[3].returnDay);
            this.props.formData.fieldValues.vatNumberDueDates[3].returnDay= this.props.formData.fieldValues.vatNumberDueDates[3].returnDay - localListingPrevMonthDays;
            localListingPrevMonthDays = 0;
            log.debug('onSubmitForm(): inside if',this.props.formData.fieldValues.vatNumberDueDates[3].returnDay);
        }
        this.props.submitHandler( MANAGED_UX_FORMS_CONTROLLER.unflattenJSON(this.props.formData.fieldValues), this.state.isSiiCertificatePresent,this.siiCertficateDetails);
        // Let the forms controller know that the form has been submitted.
        this.props.doFormSubmitted(this.props.FORM_NAME_FOR_VATNumber);

        //Reset form on create VAT number
        if(this.props.formData.fieldValues.id === 0) {
            this.props.doResetForm(this.props.FORM_NAME_FOR_VATNumber);
            //Reset values for local listing
            this.localListingPrevMonthDays = 0;
            this.localListingMonth = 1;
            this.localListingReturnDays = 0;
            this.setState({
                validValue: undefined
            })
        }
    }
    onResetForm() {
        log.debug('onResetForm(): ');
        this.props.doResetForm(this.props.FORM_NAME_FOR_VATNumber);

    }
    onClearForm() {
        log.debug('onClearForm(): ');
        this.props.doClearForm(this.props.FORM_NAME_FOR_VATNumber);

    }
}

function mapStateToProps(state, props) {
    log.debug('mapStateToProps(): ', state);
    log.debug('mapStateToProps(): props', props);

    // Because of the way the UX is designed, with multiple vatNumbers allowed to be edited, we will have multiple forms too
    // However we need to construct a unique form name per user, for the FORMS_CONTROLLER not to mix them up.
    // Using the user's email as a suffix should work for existing vatNumbers, but we will need to think about new vatNumbers.
    // TODO: how do we manage new vatNumbers? Specifically the creation of multiple new vatNumbers.
    const formNameForVATNumber = FORM_NAME+'_FOR_'+props.vatNumber.vatnumber+'_OF_COMPANY_'+props.companyCode;
    return {
        // Almost all components will need to use language strings, so add them to the props from the global state
        languages: state.languages,
        formData: (state.managedUxForms && state.managedUxForms.forms[formNameForVATNumber]),
        FORM_NAME_FOR_VATNumber: formNameForVATNumber,
        vatNumbers: state.vatNumbers,
        vatNumber :props.vatNumber,
        vatValidationRules: state.content && state.content.vatNumberRules,
        ukMTDAuthorizationurl : state.ukMTDVAT &&  state.ukMTDVAT.Authorizationurl && state.ukMTDVAT.Authorizationurl.url,
        ukMTDmanageAuthorityURL : state.ukMTDVAT &&  state.ukMTDVAT.Authorizationurl && state.ukMTDVAT.Authorizationurl.manageAuthorityURL,
        ukMTDAuthorizationstatus : ((state.ukMTDVAT &&  state.ukMTDVAT.Authorizationstatus && state.ukMTDVAT.Authorizationstatus.message &&  state.ukMTDVAT.Authorizationstatus.message.indexOf('Success') > 0) ? true : false ),
        customerId: state.authentication && state.authentication.data && state.authentication.data.customerId,
        saveCertificate :state.companies.saveCertificate ,
        saveCertificateError: state.companies.saveCertificateError,
        frequencyData : (state.content && state.content.contentData),
        countryList : (state.content && state.content.contentData && state.content.contentData.countryList)
        // TODO: Add additional data we want to extract from the global state and inject into the props here
    };
}


VATNumberForm.defaultProps = {	
    showDelete: true,
    onDeleteSIICertificateHandle : ()=>{}
}

function mapDispatchersToProps(dispatch) {
    return {
        // Standard form actions
        doInitialiseForm: (formNameForVATNumber,initialValues) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(formNameForVATNumber, initialValues));
        },
        doResetForm: (formNameForVATNumber) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(formNameForVATNumber));
        },
        doClearForm: (formNameForVATNumber) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(formNameForVATNumber));
        },
        // TO DO : Do we need to use CompanyForm name so on company submit changes will save
        onFieldChange: (formNameForVATNumber, fieldName, value) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(formNameForVATNumber, fieldName, value));
        },
        doFormSubmitted: (formNameForVATNumber) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(formNameForVATNumber));
        },
        doDestroyForm: (formNameForVATNumber) => {
            dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(formNameForVATNumber));
        },
        doValidateVATNumber: (vatnumber,callback) =>
        {
            dispatch(VATNUMBER_CONTROLLER.doValidateVATNumber(vatnumber,callback));
        },
        doUnauthenticateVATNumber: (vatnumber) =>
        {
            dispatch(UM_MTD_CONTROLLER.doUnauthenticateVATNumber(vatnumber));
        }

        //TODO: Add dispatchers (actions we expect controllers to perform) here.
    }
}
// Wrap the component to inject dispatch and state into it
export default withRouter(connect(mapStateToProps, mapDispatchersToProps)(VATNumberForm));
